const CountCard = (props) => {
  return (

    <div className="ibox float-e-margins cards">
      <div className="ibox-title">
        <h5 className="d-flex gap-2 align-items-center">
          {" "}
          {props.title == "Available Balance" ? <img src={props.icon} /> : <i className={`${props.icon} `}></i>}
          {props.title}
        </h5>
      </div>
      <div className="ibox-content">
        <h1 className="no-margins">{props.count} {props.currency}</h1>
      </div>
    </div>

  );
};

export default CountCard;
